import React from 'react';
import PageNotFound from "../IMG/notFound.jpg";

const NotFound = () => {
    return (
        <div className = "container">
            <div className="not-found">
                {/* <h2>Page Not Found</h2> */}
                
            </div>
        </div>
    );
};

export default NotFound;